export default {
    getSec(str) {
        let str1 = str.substring(1, str.length) * 1;
        let str2 = str.substring(0, 1);
        if (str2 === 's') {
            return str1 * 1000;
        } else if (str2 === 'h') {
            return str1 * 60 * 60 * 1000;
        } else if (str2 === 'd') {
            return str1 * 24 * 60 * 60 * 1000;
        } else if (str2 === 'y') {
            return str1 * 365 * 24 * 60 * 60 * 1000;
        }
    },
    set(name, value, time) {
        time = time === undefined ? 'd7' : time;
        let strsec = this.getSec(time);
        let exp = new Date();
        exp.setTime(exp.getTime() + strsec * 1);
        document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=/;domain=.bilibili.com';
    },
    get(name) {
        let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        let arr = document.cookie.match(reg);
        if (arr) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    },
    delete(name) {
        let exp = new Date();
        exp.setTime(exp.getTime() - 1);
        let cval = this.get(name);
        if (cval != null) {
            document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
        }
    }
};
